import {
  metricsMockData,
  timeperiodMockData,
  allLeadsMockData,
  leadsContactedMockData,
  leadsSoldMockData,
  segmentsMockData,
  nurturingHistoryMockData,
  mockHtml
} from 'app/pages/SalesPortalPage/LayoutV1/data/salesDemoMockData';
import { request } from 'utils/request';
import { header } from 'utils/auth';
import {
  metricTypeEnum,
  dataGridTypeEnum,
} from 'app/pages/SalesPortalPage/LayoutV1/data/type';
import { jsonObjectsToCSV } from "utils/files";
import { resolve } from 'path';

// Function to fetch metrics from mock data
const fetchMetricsFromMock = ({ dealershipId, timeperiod }): Promise<any[]> => {
  return new Promise(resolve => {
    setTimeout(() => {
      console.log(`Fetched: metrics`);
      resolve(metricsMockData);
    }, 200); // Simulate a network delay
  });
};

// Function to fetch metrics from real API
const fetchMetricsFromAPI = async ({
  dealershipId,
  timeperiod,
  useMysql,
  startDate,
  endDate,
  conversation_id
}): Promise<any> => {
  try {
    let requestURL = `/api/v2/dealers/metrics?dealer=${dealershipId}`;

    // Only add mysql parameter if it's defined
    if (useMysql !== undefined) {
      requestURL += `&mysql=${useMysql}`;
    }

    // Only send time_period for static values (not CUSTOM_RANGE)
    if (timeperiod && timeperiod !== 'CUSTOM_RANGE') {
      requestURL += `&time_period=${timeperiod}`;
    } else if (startDate && endDate) {
      // For custom date range, only send startDate and endDate
      requestURL += `&startDate=${startDate}&endDate=${endDate}`;
    }

    // Add conversation_id if provided
    if (conversation_id) {
      requestURL += `&conversation_id=${conversation_id}`;
    }

    const response: any = await request(requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (!response) {
      throw new Error('Failed to fetch metrics from API');
    }
    return response;
  } catch (error) {
    console.error('Error fetching metrics:', error);
    throw error;
  }
};

const fetchTimeperiodFromMock = ({ }): Promise<any[]> => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(timeperiodMockData);
    }, 200); // Simulate a network delay
  });
};

const fetchTimeperiodFromAPI = async ({ }): Promise<any> => {
  try {
    // const requestURL = `/api/v2/metrics?dealer=${dealershipId}&parent_group=${segmentId}`;
    // const response: any = await request(requestURL, {
    //   method: 'GET',
    //   headers: new Headers({
    //     'Content-Type': 'application/json',
    //     Authorization: header(),
    //   }),
    // });
    // console.log("response: ", response)
    // if (!response) {
    //   throw new Error('Failed to fetch metrics from API');
    // }
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(timeperiodMockData);
      }, 200); // Simulate a network delay
    });
  } catch (error) {
    console.error('Error fetching timeperiod:', error);
    throw error;
  }
};

const fetchDataGridDataFromMock = ({
  useMockData,
  filterType,
  dealershipId,
  nurturingStatus,
  timeperiod,
  groupId,
}): Promise<any> => {
  return new Promise(resolve => {
    let filteredData: any;
    switch (filterType) {
      case metricTypeEnum.opportunityAddedInNurturing:
        filteredData = allLeadsMockData;
        break;

      case metricTypeEnum.leadSold:
        filteredData = leadsSoldMockData;
        break;

      case metricTypeEnum.leadContacted:
        filteredData = leadsContactedMockData;
        break;

      case metricTypeEnum.segment:
        filteredData = segmentsMockData;
        break;

      default:
        filteredData = {};
        break;
    }


    setTimeout(() => {
      resolve(filteredData);
    }, 200); // Simulate a network delay
  });
};

const fetchDataGridDataFromAPI = async ({
  useMockData,
  useMysql,
  filterType,
  dealershipId,
  data,
}): Promise<any> => {

  try {
    let requestURL = '';
    let requestObject: any = {};

    // Only add mysql to data if it's defined
    if (useMysql !== undefined) {
      data.mysql = useMysql;
    }

    let { timeperiod } = data;
    if (
      filterType === metricTypeEnum.opportunityAddedInNurturing ||
      filterType === metricTypeEnum.leadContacted ||
      filterType === metricTypeEnum.leadSold
    ) {
      requestURL = `/api/v2/leads?dealer=${dealershipId}`;

      // Only add mysql parameter if it's defined
      if (useMysql !== undefined) {
        requestURL += `&mysql=${useMysql}`;
      }

      requestObject = {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: header(),
        }),
        body: JSON.stringify(data),
      };
    } else {
      requestURL = `/api/v2/segments?dealer=${dealershipId}`;

      // Only add mysql parameter if it's defined
      if (useMysql !== undefined) {
        requestURL += `&mysql=${useMysql}`;
      }

      if (timeperiod) {
        requestURL += `&timeperiod=${timeperiod}`;
      }

      requestObject = {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: header(),
        }),
      };
    }

    const response: any = await request(requestURL, requestObject);

    if (!response) {
      throw new Error('Failed to grid data from API');
    }
    return response;
  } catch (error) {
    console.error('Error fetching grid data:', error);
    throw error;
  }
};

const fetchNurturingHistoryFromMock = ({ }): Promise<any> => {
  nurturingHistoryMockData;
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(nurturingHistoryMockData);
    }, 200); // Simulate a network delay
  });
};

const fetchNurturingHistoryFromAPI = async ({
  opportunityId,
  dealershipId,
  useMysql
}): Promise<any> => {
  try {
    let requestURL = `/api/v2/nurturing/history/${opportunityId}?dealer=${dealershipId}&analytics=${useMysql}`;

    // Only add mysql parameter if it's defined
    if (useMysql !== undefined) {
      requestURL += `&analytics=${useMysql}`;
    }

    const response: any = await request(requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (!response) {
      throw new Error('Failed to fetch metrics from API');
    }
    return response;
  } catch (error) {
    console.error('Error fetching nurturingHistory:', error);
    throw error;
  }
};

const fetchTaskHtmlFromMock = ({ data, mysqlFlag }): Promise<any> => {
  return new Promise(resolve => {
    setTimeout(() => {

      resolve(mockHtml);
    }, 200); // Simulate a network delay
  });
};

const fetchTaskHtmlFromAPI = async ({ data, mysqlFlag }): Promise<any> => {
  try {
    let requestURL = `/api/v2/html-viewer/by-task-ids`;

    // Only add mysql parameter if it's defined
    if (mysqlFlag !== undefined) {
      requestURL += `?mysql=${mysqlFlag}`;
    }

    const response: any = await request(requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify(data)
    });
    if (!response) {
      throw new Error('Failed to fetch task html from API');
    }

    return await response.body || {};
  } catch (error) {
    console.error('Error fetching task html:', error);
    throw error;
  }
};




// Function to fetch metrics based on useMockData flag
export const fetchMetrics = async ({
  dealershipId,
  timeperiod,
  useMockData,
  useMysql,
  startDate,
  endDate,
  conversation_id
}): Promise<any[]> => {
  if (useMockData) {
    return fetchMetricsFromMock({ dealershipId, timeperiod });
  } else {
    return fetchMetricsFromAPI({ dealershipId, timeperiod, useMysql, startDate, endDate, conversation_id });
  }
};

export const fetchTimeperiod = async ({ useMockData }): Promise<any[]> => {
  if (useMockData) {
    return fetchTimeperiodFromMock({});
  } else {
    return fetchTimeperiodFromAPI({});
  }
};

export const fetchDataGridData = async ({
  useMockData,
  useMysql,
  filterType,
  dealershipId,
  nurturingStatus,
  groupId,
  timeperiod,
  data,
}): Promise<any[]> => {
  if (useMockData) {
    return fetchDataGridDataFromMock({
      useMockData,
      filterType,
      dealershipId,
      nurturingStatus,
      timeperiod,
      groupId,
    });
  } else {
    return fetchDataGridDataFromAPI({
      useMockData,
      useMysql,
      filterType,
      dealershipId,
      data,
    });
  }
};

export const fetchNurturingHistory = async ({
  useMockData,
  useMysql,
  opportunityId,
  dealershipId,
}): Promise<any[]> => {
  if (useMockData) {
    return fetchNurturingHistoryFromMock({});
  } else {
    return fetchNurturingHistoryFromAPI({ opportunityId, dealershipId, useMysql });
  }
};

export const fetchTaskHtml = async ({
  data,
  mysqlFlag,
  useMockData,
}): Promise<any> => {

  if (useMockData) {
    return fetchTaskHtmlFromMock({ data, mysqlFlag });
  } else {
    return fetchTaskHtmlFromAPI({ data, mysqlFlag });
  }
};

export const convertJsonObjects = async ({ jsonObjects, fileName }): Promise<any> => {
  let csvData = jsonObjectsToCSV(jsonObjects);
  const blobFile = new Blob([csvData], {
    type: 'text/csv',
  });

  const a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);
  const url = window.URL.createObjectURL(blobFile);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);

  return await (csvData);
};
